import type { Attrs, Mark, Node } from '@tiptap/pm/model';
import type { Editor } from '@tiptap/react';

export function isMarkInSchema(markName: string, editor: Editor | null): boolean {
  if (!editor?.schema) return false;
  return editor.schema.spec.marks.get(markName) !== undefined;
}

export function isNodeInSchema(nodeName: string, editor: Editor | null): boolean {
  if (!editor?.schema) return false;
  return editor.schema.spec.nodes.get(nodeName) !== undefined;
}

export function getActiveMarkAttrs(editor: Editor | null, markName: string): Attrs | null {
  if (!editor) return null;
  const { state } = editor;
  const marks: readonly Mark[] = state.storedMarks || state.selection.$from.marks();
  const mark: Mark | undefined = marks.find((mark): boolean => mark.type.name === markName);

  return mark?.attrs ?? null;
}

export function isEmptyNode(node?: Node | null): boolean {
  return !!node && node.content.size === 0;
}

export function shouldShow(terms: boolean[] | boolean): boolean {
  if (Array.isArray(terms)) {
    return terms.every(Boolean);
  }
  if (!terms) {
    return false;
  }
  return true;
}

export function hasExtension(editor: Editor | null, extensionNames: string | string[]): boolean {
  if (!editor) return false;

  const names: string[] = Array.isArray(extensionNames) ? extensionNames : [extensionNames];

  const check: boolean[] = names.map((name) => editor.extensionManager.extensions.some((ext) => ext.name === name));

  return check.every(Boolean);
}
